import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '../../infrastructure/di/container';
import type { CreerContributionInput, ModifierContributionInput } from '../../application/dto/dtos';

export function useContributionsParEmploye(idEmploye: string | undefined) {
  return useQuery({
    queryKey: ['contributions-employe', idEmploye],
    queryFn: () => container.listerParEmployeUseCase.execute({ idEmploye: idEmploye! }),
    enabled: !!idEmploye,
    select: (data) => data.contributions,
  });
}

export function useContributionsParProjet(idProjet: string | undefined) {
  return useQuery({
    queryKey: ['contributions-projet', idProjet],
    queryFn: () => container.listerParProjetUseCase.execute({ idProjet: idProjet! }),
    enabled: !!idProjet,
    select: (data) => data.contributions,
  });
}

export function useCreerContribution(idEmploye?: string, idProjet?: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreerContributionInput) =>
      container.creerContributionUseCase.execute(input),
    onSuccess: () => {
      if (idEmploye) qc.invalidateQueries({ queryKey: ['contributions-employe', idEmploye] });
      if (idProjet)  qc.invalidateQueries({ queryKey: ['contributions-projet', idProjet] });
    },
  });
}

export function useModifierContribution(idEmploye?: string, idProjet?: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idContribution, data }: { idContribution: string; data: ModifierContributionInput }) =>
      container.modifierContributionUseCase.execute({ idContribution, data }),
    onSuccess: () => {
      if (idEmploye) qc.invalidateQueries({ queryKey: ['contributions-employe', idEmploye] });
      if (idProjet)  qc.invalidateQueries({ queryKey: ['contributions-projet', idProjet] });
    },
  });
}

export function useSupprimerContribution(idEmploye?: string, idProjet?: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (idContribution: string) =>
      container.supprimerContributionUseCase.execute({ idContribution }),
    onSuccess: () => {
      if (idEmploye) qc.invalidateQueries({ queryKey: ['contributions-employe', idEmploye] });
      if (idProjet)  qc.invalidateQueries({ queryKey: ['contributions-projet', idProjet] });
    },
  });
}
